import { Link } from "gatsby"
import * as React from "react"

export const StrategyExecution = () => {
  return (
    <div className="container mx-auto py-10">
      <div className="mt-5 ">
        <h2 className="text-2xl text-center text-black">
          We tackle every project from{" "}
          <span className="font-bold">Strategy to Execution</span>
        </h2>
      </div>
      <div className="flex lg:flex-row flex-col mt-10 pt-10 justify-between">
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Website Development
            </p>
            <p className="text-gray text-sm">
              We offer end-to-end development across all technologies, ensuring
              high efficiency, seamless functionality, and outstanding results
              for your digital success!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Marketing Strategy
            </p>
            <p className="text-gray text-sm">
              Unlock the power of strategic marketing to boost your brand,
              engage your audience, and drive measurable results. Let’s build a
              winning plan for success!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              UI/UX Design
            </p>
            <p className="text-gray text-sm">
              We craft intuitive, user-friendly designs that enhance engagement
              and elevate your brand!
            </p>
          </div>
        </div>
      </div>
      <div className="flex lg:flex-row flex-col lg:mt-16 lg:pt-20 justify-between">
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              App Development
            </p>
            <p className="text-gray text-sm">
              We offer end-to-end app development across all technologies,
              ensuring seamless functionality, top-notch efficiency, and
              outstanding results for your business success!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Brand Development
            </p>
            <p className="text-gray text-sm">
              We craft unique brand identities that resonate, inspire, and leave
              a lasting impact. From strategy to design, we help you stand out
              and grow!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              SEO(Search Engine Optimization)
            </p>
            <p className="text-gray text-sm">
              Enhance your online presence, drive organic traffic, and rank
              higher on search engines with our expert SEO strategies. Get
              discovered and grow faster!
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4 pt-5">
        <Link to="/real-time-quote" className="px-10 bg-button-unique book-free-consultancy-radius py-3 text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass">
          See More
        </Link>
      </div>
    </div>
  )
}
